import { Fragment } from 'react';
import { Container } from 'react-bootstrap';
import AccordionDemo from '../../components/Accordion/AccordionDemo';
import AddEditBeneficiaryDemo from '../../components/AddNewBeneficiary/AddEditBeneficiaryDemo';
import AddressFormDemo from '../../components/AddressForm/AddressFormDemo';
import ApexChartDemo from '../../components/ApexCharts/ApexChartsDemo';
import AvatarDemo from '../../components/Avatar/AvatarDemo';
import BankingAccountFormDemo from '../../components/BankingAccountForm/BankingAccountFormDemo';
import BarChartDemo from '../../components/BarChart/BarChartDemo';
import BlockquoteDemo from '../../components/Blockquote/BlockquoteDemo';
import ButtonDemo from '../../components/Button/ButtonDemo';
import CalloutCardDemo from '../../components/CalloutCard/CalloutCardDemo';
import CardWithCheckboxDemo from '../../components/CardWithCheckbox/CardWithCheckboxDemo';
import ChartCardDemo from '../../components/ChartCard/ChartCardDemo';
import CheckboxDemo from '../../components/Checkbox/CheckboxDemo';
import CircledIconDemo from '../../components/CircledIcon/CircledIconDemo';
import ContactCardDemo from '../../components/ContactCard/ContactCardDemo';
import DatePickerDemo from '../../components/DatePicker/DatePickerDemo';
import DefaultCardDemo from '../../components/DefaultCard/DefaultCardDemo';
import EditableAvatarDemo from '../../components/EditableAvatar/EditableAvatarDemo';
import EmailFormDemo from '../../components/EmailForm/EmailFormDemo';
import ExpandableCardDemo from '../../components/ExpandableCard/ExpandableCardDemo';
import ExpandableContentEstimatePlanDemo from '../../components/ExpandableContentEstimatePlan/ExpandableContentEstimatePlanDemo';
import ExpandableContentPlanSelectionDemo from '../../components/ExpandableContentPlanSelection/ExpandableContentPlanSelectionDemo';
import FileInputDemo from '../../components/FileInput/FileInputDemo';
import FileUploadDemo from '../../components/FileInput/FileUploaderDemo';
import GenericCardsDemo from '../../components/GenericCards/GenericCardsDemo';
import GenericListDemo from '../../components/GenericList/GenericListDemo';
import GenericTableDemo from '../../components/GenericTable/GenericTableDemo';
import IconButtonDemo from '../../components/IconButton/IconButtonDemo';
import LabelDemo from '../../components/Label/LabelDemo';
import LinkDemo from '../../components/Link/LinkDemo';
import MenuTabsDemo from '../../components/MenuTabs/MenuTabsDemo';
import ModalDemo from '../../components/ModalHeader/ModalDemo';
import NotificationDemo from '../../components/Notification/NotificationDemo';
import NumberInputDemo from '../../components/NumberInput/NumberDemo';
import OutlinedCardDemo from '../../components/OutlinedCard/OutlinedCardDemo';
import PagerDemo from '../../components/Pager/PagerDemo';
import PhoneFormDemo from '../../components/PhoneForm/PhoneFormDemo';
import PlanCardDemo from '../../components/PlanCard/PlanCardDemo';
import PopoverDemo from '../../components/Popover/PopoverDemo';
import PreferedCardDemo from '../../components/PreferedCard/PreferedCardDemo';
import PricingCalculatorCardDemo from '../../components/PricingCalculatorCard/PricingCalculatorCardDemo';
import RadioDemo from '../../components/Radio/RadioDemo';
import RadioWithImageDemo from '../../components/RadioWithImage/RadioWithImageDemo';
import RangeSliderDemo from '../../components/RangeSlider/RangeSliderDemo';
import SearchBarDemo from '../../components/SearchBar/SearchBarDemo';
import SelectDemo from '../../components/Select/SelectDemo';
import SelectableBankCardDemo from '../../components/SelectableBankCard/SelectableBankCardDemo';
import SelectableCardDemo from '../../components/SelectableCard/SelectableCardDemo';
import SimpleAccordionDemo from '../../components/SimpleAccordion/SimpleAccordionDemo';
import SSNInputDemo from '../../components/SSNInput/SSNInputDemo';
import StepperDemo from '../../components/Stepper/StepperDemo';
import SupportDemo from '../../components/Support/SupportDemo';
import SupportMobileDemo from '../../components/Support/SupportMobileDemo';
import SwitchDemo from '../../components/Switch/SwitchDemo';
import TabsDemo from '../../components/Tabs/TabsDemo';
import TextInputDemo from '../../components/TextInput/TextInputDemo';
import UserCardsDemo from '../../components/UserCards/UserCardsDemo';
import UserCardWithInputDemo from '../../components/UserCardWithInput/UserCardWithInputDemo';
import VerticalStepsDemo from '../../components/VerticalSteps/VerticalStepsDemo';
import YourBeneficiariesDemo from '../widgets/beneficiaries/YourBeneficiaries/YourBeneficiariesDemo';
import ChangeHSAContributionsModalDemo from '../widgets/changeHSAContributionsModal/modalDemo';
import DeleteModalDemo from '../widgets/deleteModal/DeleteModalDemo';
import DependantFSAModalDemo from '../widgets/dependantFSA/modalDemo';
import FilterPopoverDemo from '../widgets/filterPopover/FilterPopoverDemo';
import HealthFSAModalDemo from '../widgets/healthFSA/modalDemo';
import HealthSavingsModalDemo from '../widgets/healthSavings/modalDemo';
import HospitalIndemnityModalDemo from '../widgets/hospitalIndemnity/modalDemo';
import HSATransactionInformationModalDemo from '../widgets/HSATransactionInformationModal/HSATransactionInformationModalDemo';
import LegalServicesModalDemo from '../widgets/legalServices/modalDemo';
import BaseLifeInsuranceModalDemo from '../widgets/lifeAndDisabilityModals/baseLifeInsurance/modalDemo';
import LongTermDisabilityServicesModalDemo from '../widgets/lifeAndDisabilityModals/longTermDisabilityServiceModal/modalDemo';
import OptionalLifeInsuranceModalDemo from '../widgets/lifeAndDisabilityModals/optionalLifeInsurance/modalDemo';
import SpouseLifeInsuranceModalDemo from '../widgets/lifeAndDisabilityModals/spouseLifeInsurance/modalDemo';
import NonTobaccoUserCreditModalDemo from '../widgets/nonTabaccoUserCredit/modalDemo';
import PensionVerificationLetterModalDemo from '../widgets/pensionVerificationLetter/modalDemo';
import PopoverWithAlertsDemo from '../widgets/PopoverAlerts/PopoverAlertsDemo';
import ReceiveFormsMailModalDemo from '../widgets/ReceiveFormsMailModal/ReceiveFormsMailDemo';
import RetireSummaryModalDemo from '../widgets/retireOnlineModals/actionsRequired/RetireSummaryModalDemo';
import MailInFormsDemo from '../widgets/retireOnlineModals/MailInFormsDemo';
import SpousalSurchargeModalDemo from '../widgets/spousalSurcharge/modalDemo';
import SuccessDialogDemo from '../widgets/success/dialogDemo';
import CriticalIllnessModalDemo from '../widgets/criticalIllnessModal/modalDemo';
import CarouselDemo from '../../components/Carousel/CarouselDemo';
import PayNowCreditActionRequiredSummary from '../widgets/PaymentInformation/PayNowCreditActionRequiredSummary';
import VideoComponentDemo from '../../components/VideoComponent/VideoComponentDemo';
import VideoEmbedModalDemo from '../widgets/VideoEmbedModal/VideoEmbedModalDemo';
import FormsOfPaymentModalDemo from '../widgets/FormsOfPaymentModal/FormsOfPaymentModalDemo';
import BenefitElectionsModalDemo from '../widgets/BenefitElectionsModal/BenefitElectionsModalDemo';
import FilterTagDemo from '../../components/FilterTag/FilterTagDemo';
import VerificationCoverageModalDemo from '../widgets/VerificationCoverageModal/VerificationCoverageModalDemo';

function Theme() {
  return (
    <Fragment>
      <Container>
        <div className="container p-0 mb-12">
          <section className="mt-4">
            <img
              src={`${process.env.PUBLIC_URL}/logo.png`}
              alt="conduent-logo"
              height={48}
            />
          </section>
          <section className="mt-6">
            <ButtonDemo />
            <IconButtonDemo />
          </section>
          <section className="mt-4">
            <CircledIconDemo />
          </section>
          <section className="mt-4">
            <AvatarDemo />
          </section>
          <section className="mt-4">
            <CheckboxDemo />
          </section>
          <section className="mt-6">
            <RadioDemo />
          </section>
          <section className="mt-6">
            <SwitchDemo />
          </section>
          <section className="mt-6">
            <TextInputDemo />
          </section>
          <section className="mt-6">
            <SearchBarDemo />
          </section>
          <section className="mt-6">
            <NumberInputDemo />
          </section>
          <section className="mt-6">
            <FileInputDemo />
          </section>
          <section className="mt-6">
            <SelectDemo />
          </section>
          <section className="mt-6">
            <DatePickerDemo />
          </section>
          <section className="mt-6">
            <SSNInputDemo />
          </section>
          <section className="mt-6">
            <SimpleAccordionDemo />
          </section>
          <section className="mt-6">
            <AccordionDemo />
          </section>
          <section>
            <ModalDemo />
          </section>
          <section className="mt-6">
            <LinkDemo />
          </section>
          <section className="mt-6">
            <LabelDemo />
          </section>
          <section className="mt-6">
            <GenericListDemo />
          </section>
          <section className="mt-6">
            <ExpandableCardDemo />
          </section>
          <section className="mt-6">
            <GenericTableDemo />
          </section>
          <section className="mt-6">
            <DefaultCardDemo />
          </section>
          <section className="mt-6">
            <SelectableCardDemo />
          </section>
          <section className="mt-6">
            <ExpandableContentEstimatePlanDemo />
          </section>
          <section className="mt-6">
            <CalloutCardDemo />
          </section>
          <section>
            <UserCardsDemo />
          </section>
          <section>
            <PricingCalculatorCardDemo />
          </section>
          <section>
            <EditableAvatarDemo />
          </section>
          <section className="mt-6">
            <PopoverDemo />
          </section>
          <section className="mt-6">
            <HealthSavingsModalDemo />
          </section>
          <section className="mt-6">
            <CriticalIllnessModalDemo />
          </section>
          <section className="mt-6">
            <BaseLifeInsuranceModalDemo />
          </section>
          <section className="mt-6">
            <OptionalLifeInsuranceModalDemo />
          </section>
          <section className="mt-6">
            <SpouseLifeInsuranceModalDemo />
          </section>
          <section className="mt-6">
            <LongTermDisabilityServicesModalDemo />
          </section>
          <section className="mt-6">
            <SpousalSurchargeModalDemo />
          </section>
          <section className="mt-6">
            <NonTobaccoUserCreditModalDemo />
          </section>
          <section className="mt-6">
            <HospitalIndemnityModalDemo />
          </section>
          <section className="mt-6">
            <LegalServicesModalDemo />
          </section>
          <section className="mt-6">
            <DependantFSAModalDemo />
          </section>
          <section className="mt-6">
            <HealthFSAModalDemo />
          </section>
          <section className="mt-6">
            <RetireSummaryModalDemo />
          </section>
          <section className="mt-6">
            <TabsDemo />
          </section>
          <section className="mt-6">
            <MenuTabsDemo />
          </section>
          <section className="mt-6">
            <ExpandableContentPlanSelectionDemo />
          </section>
          <section className="mt-6">
            <GenericCardsDemo />
          </section>
          <section className="mt-6">
            <BlockquoteDemo />
          </section>
          <section className="mt-6">
            <OutlinedCardDemo />
          </section>
          <section className="mt-6">
            <ChangeHSAContributionsModalDemo />
          </section>
          <section className="mt-6">
            <MailInFormsDemo />
          </section>
          <section className="mt-6">
            <DeleteModalDemo />
          </section>
          <section className="mt-4">
            <AddressFormDemo />
          </section>
          <section className="mt-4">
            <EmailFormDemo />
          </section>
          <section className="mt-4">
            <BankingAccountFormDemo />
          </section>
          <section className="mt-4">
            <PhoneFormDemo />
          </section>
          <section className="mt-4">
            <PreferedCardDemo />
          </section>
          <section className="mt-4">
            <StepperDemo />
          </section>
          <section className="mt-6">
            <FileUploadDemo />
          </section>
          <section className="mt-4">
            <ContactCardDemo />
          </section>
          <section className="mt-4 mb-10">
            <FilterPopoverDemo />
          </section>
          <section className="mt-4 mb-10">
            <BarChartDemo />
          </section>
          <section className="mt-4 mb-10">
            <PagerDemo />
          </section>
          <section className="mt-4 mb-10">
            <SelectableBankCardDemo />
          </section>
          <section className="mt-4 mb-10">
            <RadioWithImageDemo />
          </section>
          <section>
            <UserCardWithInputDemo />
          </section>
          <section className="mt-4 mb-10">
            <SupportMobileDemo />
          </section>
          <section className="mt-4 mb-10">
            <SupportDemo />
          </section>
          <section className="mt-4 mb-10">
            <ApexChartDemo />
          </section>
          <section className="mt-4 mb-10">
            <NotificationDemo />
          </section>
          <section className="mt-4 mb-10">
            <AddEditBeneficiaryDemo />
          </section>
          <section>
            <AddEditBeneficiaryDemo />
          </section>
          <section className="mt-4 mb-10">
            <YourBeneficiariesDemo />
          </section>
          <section>
            <RangeSliderDemo />
          </section>
          <section>
            <VerticalStepsDemo />
          </section>
          <section className="mt-6 col-6">
            <ChartCardDemo />
          </section>
          <section className="mt-6">
            <SuccessDialogDemo />
          </section>
          <section className="mt-4 mb-10">
            <CardWithCheckboxDemo />
          </section>
          <section className="mt-4 mb-10">
            <ReceiveFormsMailModalDemo />
          </section>
          <section>
            <PopoverWithAlertsDemo />
          </section>
          <section className="mt-4 mb-10">
            <HSATransactionInformationModalDemo />
          </section>
          <section className="mt-4 mb-10">
            <PlanCardDemo />
          </section>
          <section className="mt-4 mb-10">
            <PensionVerificationLetterModalDemo />
          </section>
          <section className="mt-4 mb-10">
            <CarouselDemo />
          </section>
          <section className="mt-4 mb-10">
            <PayNowCreditActionRequiredSummary />
          </section>
          <section className="mt-4 mb-10">
            <VideoComponentDemo />
          </section>
          <section className="mt-4 mb-10">
            <VideoEmbedModalDemo />
          </section>
          <section className="mt-4 mb-10">
            <FormsOfPaymentModalDemo />
          </section>
          <section className="mt-4 mb-10">
            <BenefitElectionsModalDemo />
          </section>
          <section className="mt-4 mb-10">
            <FilterTagDemo />
          </section>
          <section className="mt-4 mb-10">
            <VerificationCoverageModalDemo />
          </section>
        </div>
      </Container>
    </Fragment>
  );
}

export default Theme;
